import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

type ActiveStyles = {
  activeBg?: string;
  activeColor?: string;
};

type InactiveStyles = {
  inactiveBg?: string;
  inactiveColor?: string;
};

type Sizes = 'extrasmall' | 'small' | 'large';

interface Props {
  active?: boolean;
  count: number | string;
  activeStyles?: ActiveStyles;
  inactiveStyles?: InactiveStyles;
  size: Sizes;
  className?: string;
}

export const NumberBadge = ({
  active,
  activeStyles,
  count,
  inactiveStyles,
  size,
  ref,
  ...props
}: Props & {ref?: React.Ref<HTMLSpanElement>}) => {
  const activeBg = activeStyles?.activeBg ?? COLORS.Grey4;
  const activeColor = activeStyles?.activeColor ?? COLORS.Black;
  const inactiveBg = inactiveStyles?.inactiveBg ?? COLORS.Grey4;
  const inactiveColor = inactiveStyles?.inactiveColor ?? COLORS.Grey1;

  return (
    <Wrapper
      {...props}
      active={active}
      data-testid="numberBadge"
      activeBg={activeBg}
      activeColor={activeColor}
      inactiveBg={inactiveBg}
      inactiveColor={inactiveColor}
      size={size}
      ref={ref}
    >
      {count}
    </Wrapper>
  );
};

const badgePaddingBySize: Record<Sizes, number> = {
  extrasmall: 6,
  small: 8,
  large: 10,
};
const Wrapper = styled.span<{
  active?: boolean;
  activeBg: string;
  activeColor: string;
  inactiveBg: string;
  inactiveColor: string;
  size: Sizes;
}>`
  align-items: center;
  background-color: ${({active, activeBg, inactiveBg}) =>
    active ? activeBg : inactiveBg};
  border-radius: 11px;
  box-sizing: border-box;
  color: ${({active, activeColor, inactiveColor}) =>
    active ? activeColor : inactiveColor};
  display: inline-flex;
  flex-grow: 0;
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.bold};
  height: ${({size}) => (size === 'large' ? '22px' : '19px')};
  justify-content: center;
  min-width: ${({size}) => (size === 'extrasmall' ? 'unset' : '30px;')};
  padding: ${({size}) => `0 ${badgePaddingBySize[size]}px`};
  text-align: center;
  width: auto;
  letter-spacing: 1px;
`;
